module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', [_c('span', [_c('b', [_vm._v(_vm._s(_vm.currentNote.Time) + " " + _vm._s(_vm.currentNote.UserFullName))])]), _c('span', [_vm._v(" (" + _vm._s(_vm.currentNote.UserType) + ")")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentNote.Info),
      expression: "currentNote.Info"
    }],
    ref: "elText",
    class: ['txtNote', _vm.isTopNote ? 'topNote' : ''],
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": (_vm.currentNote.Info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentNote.Info = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.currentNote.Attachments) ? _c('div', {
    staticClass: "filesList"
  }, _vm._l((_vm.currentNote.Attachments), function(file) {
    return _c('div', [_c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:bottom",
        value: ({
          html: 'מחק קובץ'
        }),
        expression: "{ html: 'מחק קובץ' }",
        arg: "bottom"
      }],
      staticClass: "btnIcon mr-2 ml-2",
      on: {
        "click": function($event) {
          _vm.removeFile(file)
        }
      }
    }, [_vm._v("delete")]), _vm._v(" "), _c('a', {
      attrs: {
        "target": "_blank",
        "href": file.FileUrl
      }
    }, [_vm._v(_vm._s(file.FileName))])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.showProgress) ? _c('div', [_vm._v("מעלה קובץ ...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "noteCtrls"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('Recorder', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "record:start": function($event) {}
    }
  }), _vm._v(" "), (_vm.$root.isContractor || _vm.$root.isInspector) ? _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("\n         \n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isTopNote),
      expression: "isTopNote"
    }],
    staticClass: "w3-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isTopNote) ? _vm._i(_vm.isTopNote, null) > -1 : (_vm.isTopNote)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isTopNote,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isTopNote = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isTopNote = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isTopNote = $$c
        }
      }
    }
  }), _vm._v(" פיקוח עליון\n      ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "file-select"
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'העלאת קובץ'
      }),
      expression: "{ html: 'העלאת קובץ' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2",
    attrs: {
      "right": ""
    }
  }, [_vm._v("attachment")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.upload
    }
  })], 1), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'שמירה'
      }),
      expression: "{ html: 'שמירה' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("save")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'ביטול'
      }),
      expression: "{ html: 'ביטול' }",
      arg: "bottom"
    }],
    staticClass: "btnIcon mr-2 ml-2",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f1dc926"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoteEditor.vue
// module id = 880
// module chunks = 2